<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Archive Purchase Order</p>
      </header>
      <section class="modal-card-body">
        <div class="pa-xl has-text-centered">
          Are you sure you want to archive this purchase order?
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-danger"
          native-type="submit"
          :loading="saving"
          :disabled="!ready || saving"
        >Archive</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  computed: {
    ...mapGetters(['api', 'context']),
    endpoint () {
      return this.api.route + '/purchase-orders/' + this.$route.params.id
    },
    ready () {
      return true
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http.delete(this.endpoint).then(response => {
        this.$parent.close()
        this.$buefy.toast.open({ type: 'is-info', message: 'Purchase Order Archived!' })
        this.$emit('po:archived', response.data)
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  data () {
    return {
      saving: false,
      errors: []
    }
  },
  props: ['order']
}
</script>
